import ApiService from "../../../services/ApiService";

async function assertOk(request) {
    const result = await request;
    if (result?.code && result.code !== "SUCCESS") {
        throw new Error(result.message || "Request failed");
    }
    return result;
}

const AdminWordWheelPackService = {
    list: async () => {
        const result = await assertOk(ApiService.getData("/v1/puzzle/wordwheel-pack"));
        return result?.items || [];
    },

    create: async (body) => assertOk(ApiService.postData("/v1/puzzle/wordwheel-pack", body)),

    generate: async (code) => assertOk(ApiService.postData(`/v1/puzzle/wordwheel-pack/${code}/generate`, {})),

    reorder: async (code) => assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${code}/reorder`, {})),

    regenerateClues: async (code) =>
        assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${code}/regenerate-clues?language=english&dryRun=false`, {})),

    fillMissingClues: async (code) =>
        assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${code}/fill-missing-clues?language=english&dryRun=false`, {})),

    removeDuplicates: async (code) =>
        assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${code}/remove-duplicates?language=english&dryRun=false`, {})),

    setLocked: async (code, locked) =>
        assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${encodeURIComponent(code)}/locked`, { locked: !!locked })),

    level: async (code, level) =>
        assertOk(ApiService.getData(`/v1/puzzle/wordwheel-pack/${code}/level/${level}`)),

    replaceLevel: async (code, level) =>
        assertOk(ApiService.putData(`/v1/puzzle/wordwheel-pack/${code}/level/${level}/replace`, {})),

    /** Build journey_* from pack level titles (classic/hard_quest/master). */
    makeJourney: async (code, replace = false) =>
        assertOk(ApiService.postData(
            `/v1/puzzle/wordwheel-pack/${encodeURIComponent(code)}/make-journey?replace=${replace ? "true" : "false"}`,
            {}
        )),
};

export default AdminWordWheelPackService;
